<template>
  <component
    :is="baseComponent"
    v-if="hasAccess"
    :to="{ name: link.name ? link.name : 'home' }"
    :class="{
      active: isActive || $route.fullPath.startsWith(resolvePath(link))
    }"
    tag="li"
  >
    <a
      v-if="isMenu"
      data-toggle="collapse"
      href="javascript:void(0)"
      @click="collapseMenu"
    >
      <i :class="link.icon" />
      <p>
        {{ link.title }}
        <b class="caret" />
      </p>
    </a>
    <div v-if="$slots.default || isMenu">
      <el-collapse-transition>
        <ul
          v-show="!collapsed"
          class="nav"
        >
          <slot />
        </ul>
      </el-collapse-transition>
    </div>
    <slot
      v-if="children.length === 0 && !$slots.default && link.name"
      title="title"
    >
      <component
        :is="elementType(link, false)"
        :to="{ name: link.name }"
        :class="{ active: link.active, highlight: link.highlight }"
        :target="link.target"
        :href="`/#${resolvePath(link)}`"
        :data-active-color="'purple'"
      >
        <template v-if="addLink">
          <div @click="toggleSidebar">
            <span class="sidebar-mini"><i :class="link.icon" /></span>
            <span class="sidebar-normal">{{ link.title }}</span>
          </div>
        </template>
        <template v-else>
          <i :class="link.icon" />
          <p>{{ link.title }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import check from "@/components/acl/check";
import getMatchers from "@/components/acl/getMatchers";

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {
        return {
          title: "",
          path: "",
          children: []
        };
      }
    }
  },
  data() {
    return {
      children: [],
      collapsed: true
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route) {
        let matchingRoute = this.children.find(c =>
          this.$route.path.startsWith(this.resolvePath(c.link))
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
    hasAccess() {
      // Double check this
      const matchers = getMatchers({
        permissions: this.link.permissions,
        roles: this.link.roles,
        features: this.link.features,
        tier: this.link.tier
      });

      return check(matchers);
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  unmounted() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
  methods: {
    addChild(item) {
      // TODO: remove this eslint-disable when update to vue v3
      // eslint-disable-next-line vue/require-slots-as-functions
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(title) {
      const matches = title.match(/\b(\w)/g);
      return matches.join("");
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
    resolvePath(link) {
      const route = this.$router
        .getRoutes()
        .find(route => route.name === link.name);
      return route.path;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.highlight {
  opacity: 1 !important;
}
</style>
